import { useState } from "react";
import "./editorialForms.css";

const travelTypes = [
  { id: "adventure", name: "Aventura" },
  { id: "beach", name: "Praia" },
  { id: "cultural", name: "Cultural" },
  { id: "romantic", name: "Romântica" },
  { id: "family", name: "Família" },
  { id: "business", name: "Negócios" },
  { id: "solo", name: "Solo" },
  { id: "backpacking", name: "Mochilão" },
  { id: "luxury", name: "Luxo" },
  { id: "ecotourism", name: "Ecoturismo" },
];

export default function TravelForm({ data, onChange }) {
  const [tipInput, setTipInput] = useState("");
  const [mustSeeInput, setMustSeeInput] = useState("");

  const handleAddTip = () => {
    if (tipInput.trim()) {
      onChange({
        ...data,
        tips: [...(data?.tips || []), tipInput.trim()],
      });
      setTipInput("");
    }
  };

  const handleRemoveTip = (index) => {
    onChange({
      ...data,
      tips: (data?.tips || []).filter((_, i) => i !== index),
    });
  };

  const handleAddMustSee = () => {
    if (mustSeeInput.trim()) {
      onChange({
        ...data,
        mustSee: [...(data?.mustSee || []), mustSeeInput.trim()],
      });
      setMustSeeInput("");
    }
  };

  const handleRemoveMustSee = (index) => {
    onChange({
      ...data,
      mustSee: (data?.mustSee || []).filter((_, i) => i !== index),
    });
  };

  return (
    <div className="editorial_form travel_form">
      <div className="editorial_form_section">
        <label>
          Nome do Destino <span className="required">*</span>
        </label>
        <input
          type="text"
          placeholder="Ex: Machu Picchu, Paris, Fernando de Noronha..."
          value={data?.destinationName || ""}
          onChange={(e) => onChange({ ...data, destinationName: e.target.value })}
        />
      </div>

      <div className="editorial_form_row">
        <div className="editorial_form_section">
          <label>País</label>
          <input
            type="text"
            placeholder="Ex: Peru, França, Brasil..."
            value={data?.country || ""}
            onChange={(e) => onChange({ ...data, country: e.target.value })}
          />
        </div>

        <div className="editorial_form_section">
          <label>Cidade</label>
          <input
            type="text"
            placeholder="Cidade"
            value={data?.city || ""}
            onChange={(e) => onChange({ ...data, city: e.target.value })}
          />
        </div>
      </div>

      <div className="editorial_form_section">
        <label>Descrição da Viagem</label>
        <textarea
          placeholder="Conte sobre sua experiência, o que fazer, como chegar..."
          value={data?.description || ""}
          onChange={(e) => onChange({ ...data, description: e.target.value })}
          maxLength={3000}
          rows={4}
        />
      </div>

      <div className="editorial_form_row">
        <div className="editorial_form_section">
          <label>Tipo de Viagem</label>
          <select
            value={data?.travelType || ""}
            onChange={(e) => onChange({ ...data, travelType: e.target.value })}
          >
            <option value="">Selecione</option>
            {travelTypes.map((type) => (
              <option key={type.id} value={type.id}>
                {type.name}
              </option>
            ))}
          </select>
        </div>

        <div className="editorial_form_section">
          <label>Duração</label>
          <input
            type="text"
            placeholder="Ex: 5 dias, 2 semanas..."
            value={data?.duration || ""}
            onChange={(e) => onChange({ ...data, duration: e.target.value })}
          />
        </div>
      </div>

      <div className="editorial_form_row">
        <div className="editorial_form_section">
          <label>Orçamento (R$)</label>
          <input
            type="number"
            placeholder="Valor total ou diário"
            value={data?.budget?.amount || ""}
            onChange={(e) =>
              onChange({
                ...data,
                budget: {
                  ...data?.budget,
                  amount: parseFloat(e.target.value) || 0,
                  currency: "BRL",
                },
              })
            }
            min="0"
          />
        </div>

        <div className="editorial_form_section">
          <div className="editorial_form_checkbox" style={{ marginTop: "28px" }}>
            <input
              type="checkbox"
              id="budgetPerDay"
              checked={data?.budget?.perDay || false}
              onChange={(e) =>
                onChange({
                  ...data,
                  budget: { ...data?.budget, perDay: e.target.checked },
                })
              }
            />
            <label htmlFor="budgetPerDay">Valor por dia</label>
          </div>
        </div>

        <div className="editorial_form_section">
          <label>Avaliação (1-5)</label>
          <input
            type="number"
            placeholder="4.5"
            value={data?.rating || ""}
            onChange={(e) =>
              onChange({ ...data, rating: parseFloat(e.target.value) || 0 })
            }
            min="1"
            max="5"
            step="0.1"
          />
        </div>
      </div>

      <div className="editorial_form_section">
        <label>Melhor Época para Visitar</label>
        <input
          type="text"
          placeholder="Ex: De abril a outubro, evite a época de chuvas..."
          value={data?.bestTimeToVisit || ""}
          onChange={(e) => onChange({ ...data, bestTimeToVisit: e.target.value })}
        />
      </div>

      <div className="editorial_form_section">
        <label>
          O que Fazer (Imperdível)
          <button
            type="button"
            className="add_variant_btn"
            onClick={handleAddMustSee}
          >
            + Adicionar
          </button>
        </label>
        <input
          type="text"
          placeholder="Ex: Visitar o museu, trilha na montanha..."
          value={mustSeeInput}
          onChange={(e) => setMustSeeInput(e.target.value)}
          onKeyPress={(e) => e.key === "Enter" && handleAddMustSee()}
        />
        <div className="genre_chips" style={{ marginTop: "8px" }}>
          {(data?.mustSee || []).map((item, i) => (
            <span
              key={i}
              className="genre_chip selected"
              onClick={() => handleRemoveMustSee(i)}
              style={{ cursor: "pointer" }}
            >
              {item} ×
            </span>
          ))}
        </div>
      </div>

      <div className="editorial_form_section">
        <label>
          Dicas
          <button
            type="button"
            className="add_variant_btn"
            onClick={handleAddTip}
          >
            + Adicionar
          </button>
        </label>
        <input
          type="text"
          placeholder="Ex: Leve protetor solar, reserve com antecedência..."
          value={tipInput}
          onChange={(e) => setTipInput(e.target.value)}
          onKeyPress={(e) => e.key === "Enter" && handleAddTip()}
        />
        <div className="genre_chips" style={{ marginTop: "8px" }}>
          {(data?.tips || []).map((tip, i) => (
            <span
              key={i}
              className="genre_chip selected"
              onClick={() => handleRemoveTip(i)}
              style={{ cursor: "pointer" }}
            >
              {tip} ×
            </span>
          ))}
        </div>
      </div>

      <div className="editorial_form_tip">
        <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
          <path d="M21 16v-2l-8-5V3.5c0-.83-.67-1.5-1.5-1.5S10 2.67 10 3.5V9l-8 5v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5l8 2.5z" />
        </svg>
        <span>
          Compartilhe fotos incríveis e inspire outros viajantes!
        </span>
      </div>
    </div>
  );
}
